import React, {createContext, useEffect, useReducer} from 'react';
import {BrowserRouter} from "react-router-dom";
import Router from "./pages/Router";
import ScrollTopTop from './components/scroll/ScrollToTop';
import {appReducer, getInitialStoreState, iStoreState} from "./reducer";
import ReactGA from 'react-ga';

export const AppStateContext = createContext<iStoreState>(getInitialStoreState());
export const AppDispatchContext = createContext<any>({});

if (process.env.REACT_APP_GA_CODE) {
    ReactGA.initialize(process.env.REACT_APP_GA_CODE);
} else {
    ReactGA.initialize('GTM-NHKPNBC');
}

const App = () => {
    const [state, dispatch] = useReducer(appReducer, getInitialStoreState());
    useEffect(() => {
        if (process.env.REACT_APP_GUIDE_BOT === "1") {

            let guide_bot = document.getElementById("guided_bot");
            if (guide_bot) {
                guide_bot.setAttribute("data-client-id",process.env.REACT_APP_GUIDE_BOT_CLIENT_ID||"");
            }
            let myScript = document.createElement("script");
            myScript.setAttribute("src", "https://chat-widget.volobot.com/embed.chat.volobot.js?v=9");
            document.body.appendChild(myScript);
        }
    }, [])
    return <BrowserRouter>
        <AppDispatchContext.Provider value={dispatch}>
            <AppStateContext.Provider value={state}>
                <ScrollTopTop/>
                <Router/>
            </AppStateContext.Provider>
        </AppDispatchContext.Provider>
    </BrowserRouter>
}


export default App;
